
import { ApplicationState, ApplicationStatus, applicationStatusFromState } from '../../domain/types';
import useGetDeclinedOfferReason from '../../hooks/useGetDeclinedOfferReason';
import StatusCompletePage from './CompletePage/StatusCompletePage';
import StatusDeclinedPage from './DeclinedPage/StatusDeclinedPage';
import StatusErrorPage from './ErrorPage/StatusErrorPage';
import StatusInspectionPage from './InspectionPage/StatusInspectionPage';
import StatusProcessingPage from './ProcessingPage/StatusProcessingPage';
import StatusWaitingPage from './WaitingPage/StatusWaitingPage';

type Props = {
    applicationState?: ApplicationState;
};

const StatusDeclinedPageWrapper = () => {
    const { reason } = useGetDeclinedOfferReason();
    return <StatusDeclinedPage reason={reason[0]} />;
};

const OngoingStaticPage = ({ applicationState }: Props) => {
    const applicationStatus = applicationStatusFromState(applicationState);

    switch (applicationStatus) {
        case ApplicationStatus.complete:
            return <StatusCompletePage />;
        case ApplicationStatus.declined:
            return <StatusDeclinedPageWrapper />;
        case ApplicationStatus.inspection:
            return <StatusInspectionPage />;
        case ApplicationStatus.error:
            return <StatusErrorPage />;
        case ApplicationStatus.processing:
            return <StatusProcessingPage />;
        case ApplicationStatus.waiting:
            return <StatusWaitingPage />;
        default:
            return <StatusProcessingPage />;
    }
};

export default OngoingStaticPage;
